import React from 'react'

import Transition from './Pieces/Transition'

import '../../scss/components/_loading-overlay.scss'

const LoadingOverlay = () => (
  <Transition enter={{opacity: 1}} leave={{opacity: 0}}>
    <div
      key="0"
      className="loading-overlay"
      style={{
        opacity: '0',
      }}
    >
      <div className="loading-overlay-inner">
        <div className="loading-overlay-dots">
          <div className="loading-overlay-dot" />
          <div className="loading-overlay-dot" />
          <div className="loading-overlay-dot" />
        </div>
      </div>
    </div>
  </Transition>
)

export default LoadingOverlay
